"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoyIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class BoyIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("g", { transform: "translate(6.000000, 0.000000)" },
                        React.createElement("path", { d: "M6.5,8 C8.706,8 10.5,6.206 10.5,4 C10.5,1.794 8.706,0 6.5,0 C4.294,0 2.5,1.794 2.5,4 C2.5,6.206 4.294,8 6.5,8" }),
                        React.createElement("path", { d: "M12,9 L1,9 C0.724,9 0.5,9.224 0.5,9.5 C0.5,14.328 2.583,16.423 4,17.289 L4,23.5 C4,23.776 4.224,24 4.5,24 L8.5,24 C8.776,24 9,23.776 9,23.5 L9,17.289 C10.417,16.423 12.5,14.327 12.5,9.5 C12.5,9.224 12.276,9 12,9" }))))));
    }
}
exports.BoyIcon = BoyIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/boy.tsx
// module id = 2128
// module chunks = 0 1 2